import { Typography } from '@mui/material';
import { useState } from 'react';
import CustomTable from 'src/components/Table';
import { useQueryCompanyMarketPlace } from 'src/services/queries';
import { EmptyText } from 'src/utils/constants/config';
import { getStringOrDefault, renderTextOrDefault } from 'src/utils/helpers/stringHelpers';

const StockTable = ({ id = '' }: { id?: string | null }) => {
  const [params, setParams] = useState({
    limit: 10,
    offset: 0,
  });

  const { data, isFetching, refetch } = useQueryCompanyMarketPlace({
    id: getStringOrDefault(id),
    params: params,
  });

  const configColumn: ConfigCell<ICompanyMarketPlace>[] = [
    {
      disablePadding: false,
      id: 'symbol',
      label: 'Symbol',
      cell: (data: ICompanyMarketPlace) => (
        <Typography variant="body2" color={'text.secondary'}>
          {renderTextOrDefault(data.symbol)}
        </Typography>
      ),
    },
    {
      disablePadding: false,
      id: 'name',
      label: 'Name',
      cell: (data: ICompanyMarketPlace) => (
        <Typography variant="body2" color={'text.secondary'}>
          {renderTextOrDefault(data.name)}
        </Typography>
      ),
    },
    {
      disablePadding: false,
      id: 'stock_price',
      label: 'Stock Price',
      cell: (data: ICompanyMarketPlace) => (
        <Typography variant="body2" color={'text.secondary'}>
          {renderTextOrDefault(data.stock_price)}
        </Typography>
      ),
    },
    {
      disablePadding: false,
      id: 'daily_change',
      label: 'Daily Change (%)',
      cell: (data: ICompanyMarketPlace) => {
        if (!data.daily_change) {
          return EmptyText;
        }
        const color = data.daily_change
          ? Number(data.daily_change) > 0
            ? 'success.main'
            : 'error.main'
          : 'text.secondary';
        return (
          <Typography variant="body2" color={color}>
            {data.daily_change + '%'}
          </Typography>
        );
      },
    },
    {
      disablePadding: false,
      id: 'stock_exchange',
      label: 'Stock Exchange',
      cell: (data: ICompanyMarketPlace) => (
        <Typography variant="body2" color={'text.secondary'}>
          {renderTextOrDefault(data.stock_exchange_name)}
        </Typography>
      ),
    },
    {
      disablePadding: false,
      id: 'stock_exchange_mic',
      label: 'Stock Exchange (MIC)',
      cell: (data: ICompanyMarketPlace) => (
        <Typography variant="body2" color={'text.secondary'}>
          {renderTextOrDefault(data.stock_exchange_mic)}
        </Typography>
      ),
    },
    {
      disablePadding: false,
      id: 'country',
      label: 'Country',
      cell: (data: ICompanyMarketPlace) => (
        <Typography variant="body2" color={'text.secondary'}>
          {renderTextOrDefault(data.country)}
        </Typography>
      ),
    },
  ];
  return (
    <CustomTable
      onChangePage={(e) => setParams({ ...params, ...{ offset: e } })}
      onChangePageSize={(e) => setParams({ ...params, ...{ offset: 0, limit: e } })}
      loading={isFetching}
      page={data.page}
      pageSize={data.page_size}
      totalRecords={data?.total_records || 0}
      dataKey={'id'}
      data={data.data}
      configColumn={configColumn}
    />
  );
};

export default StockTable;
